import React, { useCallback } from 'react';
import classNames from 'classnames';
import {
  Card as FluentCard,
  Caption1,
  Text,
  Image,
} from '@fluentui/react-components';
import { CheckmarkCircleFilled } from '@fluentui/react-icons';

import { CARD_CONFIG } from './card-config';
import { CardProps } from './types';
import { useCardStyles } from './styles/card-styles';

export function Card({
  i18n,
  cardId,
  isSelected,
  onCardSelectionChange,
}: CardProps) {
  const styles = useCardStyles() as any;
  const onCardClicked = useCallback(() => onCardSelectionChange(cardId, !isSelected), [cardId, isSelected, onCardSelectionChange]);
  const handleSpace = useCallback((e) => {
    if (e.key === ' ') {
      onCardClicked();
    }
  }, [onCardClicked]);
  if (!CARD_CONFIG[cardId]) return null;
  return (
    <FluentCard onClick={onCardClicked} onKeyDown={handleSpace} className={classNames('card', cardId, isSelected ? styles.cardSelected : styles.card)}>
      <header className={styles.header}>
        <Image className={classNames('image', styles.image)} src={CARD_CONFIG[cardId].icon} alt={i18n.getString(CARD_CONFIG[cardId].title)} />
        {isSelected && <CheckmarkCircleFilled className={classNames('checkmark', styles.checkmark)} />}
      </header>
      <div className={styles.textArea}>
        <Text weight="semibold" className={classNames('card-title', styles.title)}>
          {i18n.getString(CARD_CONFIG[cardId].title)}
        </Text>
        <Caption1 className="card-description">{i18n.getString(CARD_CONFIG[cardId].description)}</Caption1>
      </div>
    </FluentCard>
  );
}
